export const gaSendEvent = options => {
  if (window.ga) {
    window.ga('send', 'event', options);
  }
};
